/// <reference path="../onlinePresenceSettings.module.ts" />

module Meevo.Plugins.OnlinePresenceSettings {

    interface IYextBusinessInfo {

    }

    class BusinessInfoModalController {

        static $inject = [
            '$mdDialog',
            'businessInfo',
            'primaryCategory'
        ];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            public businessInfo: IYextBusinessInfo,
            public primaryCategory: string,
        ) {}

        apply = () => {
            this.$mdDialog.hide(true);
        };

        cancel = () => {
            this.$mdDialog.hide(false);
        };
        getShortWeekName(weekDay?: string) {
            if (weekDay != undefined && weekDay != null) { return weekDay.substr(0, 3); }
            else { return null; }
        }
    }

    angular.module("meevo.plugins.onlinePresenceSettings")
        .controller("meevo.plugins.onlinePresenceSettings.BusinessInfoModalController", BusinessInfoModalController);
}